import { Params } from '@angular/router';

import { UserStatistics } from './UserInterfaces';
import { ManagedDataReply, NameValue, WidgetConfiguration, DataPolicy } from './WidgetInterfaces';
import { Dictionary } from '../classes/UtilityFunctions';
import { Observable } from 'rxjs/Observable';
import { QueueingSubject } from 'queueing-subject';

export class DataRequestError {
    constructor(public widgetName: string, public dataPolicy: string, public RequestKey: string, public ErrorMessage: string) {}
}

export class DataRequestReply {
    RequestKey: string;
    Available: boolean;
    ImmediateManagedDataReply: ManagedDataReply;
    rawReply: any;

    constructor(requestKey: string, available: boolean, managedDataReply: ManagedDataReply = null, rawReply: any = null) {
        this.RequestKey = requestKey;
        this.Available = available;
        this.ImmediateManagedDataReply = managedDataReply;
        this.rawReply = rawReply;
    }
}

export class WebSocketData {
    WebSocketKey: string;
    InputStream: QueueingSubject<string>;
    ConnectionStatus: Observable<any>;
    Messages: Observable<any>;
    constructor(WebSocketKey: string) {
        this.WebSocketKey = WebSocketKey;
        this.InputStream = new QueueingSubject<string>();
    }
}

/**
 * AppState is used by  DisplayStateService and most of the components in the WidgetDisplayModule for tracking:
 * - data retrieved from backend web service for side nav config and associated data sets
 * - display state - side nav toggle, current side nav config, side nav display hierarchy and data, current context or filters
 */
export class AppDisplayState {
    // side nav configuration and data set lists - retrieved at startup and cached until user explicitly refreshes
    sideNavWidgetConfig: SideNavWidgetConfig;
    widgetConfigList: WidgetConfiguration[] = [];

    cachedDataReplies: Dictionary<string, ManagedDataReply> = new Dictionary<string, ManagedDataReply>();
    pendingDataReplies: string[] = [];
    // All current state
    current: CurrentAppState = new CurrentAppState();

    apiVersion: string;
}

// Keeps track of all current application state
export class CurrentAppState {
    context: Params = [];
    filters: Params = [];
    sorts:  Params = [];
    sideNav: SideNavState = {widgetName: '', displayName: '', filter: '', displayState: 'show'};
    breadcrumb = 'show';
    widthClass = 'col-md-6';
    canvasHeight: string;
    perRow = '2';
    cachePolicy = 'default';
    user: adal.User;
    xMtAdfsOpenid: string;
    preferredSettings: UserStatistics = undefined;
    userIsAdmin = false;
    isPrintMode = false;
    token: string;
    userStatistics: UserStatistics;
    appTitle: string;
    webSockets: WebSocketData[] = [];
    contextHist?: {key:string, prevValues: string[]}[] = []; // if context rule is allowed to keep history, store the recent context values here.
}

export interface SideNavState {
    widgetName: string;
    displayName: string;
    filter: string;
    displayState: string;

}

// describes the side nav config stored as an array of these objects in the eng backend database that is used for side nav options
export interface SideNavWidgetConfig {
    widgetNameList: SideNavList[];
}

export interface SideNavList{
    name: string;
    value: string;
    modified?: boolean;
    dateModified? : string;
    unSavedData? : boolean;
    WidgetInternalSideNav? : boolean; // true if this side nav is built into the widget configured as an "app"   
}

export interface ConflictViewer{
    category: string,
    widgetName: string,
    modifiedDbDate?: string,
    data: ConflictData
}

export interface ConflictData{
    dbCopy: SideNavList | WidgetConfiguration | DataPolicy,
    userCopy: SideNavList | WidgetConfiguration | DataPolicy
}

// Generic data set stored in the eng backend and used for all cached data
export interface DataSet {
    columns: string[];
    data: string [][];
}

// Another data format (expanded dataset where property name is column name and each item in the array is an simple object)
export interface DataArrayOfObjects extends Array<object>{};

export class ManagedCacheHitLog {
    dateTime: string;
    type: string;
    client: string;
    dataPolicy: string;
    key: string;
    Status: string;
    Message: string;
    cacheRefresh: boolean;
    elapsedMs: number;
}

export interface CustomMenu {
    name: string;
    menuItems: CustomMenuItem[];
}

export interface CustomMenuItem {
    name: string;
    handler: () => void;
}

export class GroupedKey {

  context: Params;
  children: GroupedKey[];
  badge: string;
  key: string;
  visible: boolean;

  constructor(public granularity: string, public name: string, parentGC?: GroupedKey) {
      this.context = [];
      this.children = [];
      this.key = granularity + '_' + name;
      this.key = this.key.replace(' ', '_sp_').replace('.', '_dot_');
      this.visible = true;
      if (parentGC) {
          this.key = parentGC.key + '_' + this.key;
      }
  }
}
